import { createContext } from 'react';

export type WhiteTriangleContextProps = {
  requisitesId?: string;
  isWhiteTriangle?: boolean;
  renderLeftContent?: () => React.ReactNode;
};

export const WhiteTriangleContext = createContext<WhiteTriangleContextProps>(
  {} as WhiteTriangleContextProps,
);
